import React, {useState, useEffect} from "react";

import FaqsContent from "../content/FaqsContent";

import Navbar from "../inc/Navbar";
import Footer from "../inc/Footer";

import { Helmet } from "react-helmet-async";
import LoadingBar from 'react-top-loading-bar';

function Faqs() {

    const [progress, setProgress] = useState(0);
    
    useEffect(()=>{
        setProgress(100);
    },[])

    return(
        <>
        <Helmet>
            <title>FAQs | Suvivah - Frequently Asked Questions</title>

            <meta
                name="description"
                content="Find answers to frequently asked questions about Suvivah, registration, profile creation, matchmaking, account management, privacy, and other matrimonial services."
            />

            <meta
                name="keywords"
                content="Suvivah FAQs, Matrimonial FAQ, Marriage Questions, Registration Help, Profile Help, Matchmaking Support"
            />

            <meta name="robots" content="index, follow" />
            <meta name="author" content="Suvivah" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="theme-color" content="#dc3545" />

            <link rel="canonical" href="https://suvivah.org/faqs" />

            <meta property="og:type" content="website" />
            <meta property="og:site_name" content="Suvivah" />
            <meta property="og:locale" content="en_IN" />
            <meta
                property="og:title"
                content="FAQs | Suvivah - Frequently Asked Questions"
            />
            <meta
                property="og:description"
                content="Get answers to common questions about Suvivah, registration, profile management, and matrimonial services."
            />
            <meta property="og:url" content="https://suvivah.org/faqs" />
            <meta
                property="og:image"
                content="https://suvivah.org/images/logo.png"
            />

            <meta name="twitter:card" content="summary_large_image" />
            <meta
                name="twitter:title"
                content="FAQs | Suvivah - Frequently Asked Questions"
            />
            <meta
                name="twitter:description"
                content="Find answers to common questions about Suvivah and our matrimonial services."
            />
            <meta
                name="twitter:image"
                content="https://suvivah.org/images/logo.png"
            />
        </Helmet>

        <Navbar />
        <FaqsContent/>
        <LoadingBar
            color='#a11800'
            height={4}
            background='#fff4a1'
            loaderSpeed={2000}
            waitingTime={2000}
            shadow={true}
            progress={progress}
            onLoaderFinished={() => setProgress(0)}
        />
        <Footer />        
        </>
    );
}

export default Faqs;